import React from 'react';
import styled from 'styled-components';

const VisualWrapper = styled.div`
  margin-top: 12px;
  background: #ffffff;
  min-height: 200px;
  border: 1px solid #d5d9dd;
  border-radius: 8px;

  ${p => p.height && `
    height: ${p.height};
  `}

  ${p => p.noMargin && `
    margin: 0;
  `}

  ${p => p.noBorder && `
    border: 0;
  `}

  ${p => p.noBackground && `
    background: none;
  `}

  ${p => p.autoHeight && `
    min-height: auto;
  `}

  ${p => p.padding && `
    padding: ${p.padding};
  `}

  ${p => p.borderColor && `
    border-color: ${p.borderColor};
  `}

  ${p => p.background && `
    background-color: ${p.background};
  `}

  ${p => p.flexCenter && `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  `}

  ${p => p.flexDirection && `
    flex-direction: ${p.flexDirection};
  `}

  ${p => p.gap && `
    gap: ${p.gap};
  `}

  img {
    width: 100%;
  }
`;

const Visual = ({ noMargin, data, ...rest }) => (
  <VisualWrapper noMargin={noMargin || false} {...rest}>
    {data || null}
  </VisualWrapper>
);

export default Visual;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/visual.js